<template>
  <div class="wrapper hefei-bg-f5" style="display: flex;flex-direction:column;">
    <div class="guide-search">
      <div class="search-cont" :class="{focus: (isFocus)}">
        <div class="input-wrap">
          <input
            type="text"
            name="search"
            placeholder="搜索医院"
            v-model="content"
            @change="updateHistory"
            @input="focus"
            @blur="blur"
          />
        </div>
        <img
          v-show="isFocus"
          @click.stop="clear"
          src="../../assets/images/jidayi-hospital/icon-search-close.png"
        />
      </div>
    </div>
    <div class="container-wrap-form" style="flex: auto;">
      <div class="search-cue" v-if="!menuShow">
        <ul >
          <!-- <li>全部医院 <em class="visit">最近就诊</em></li> -->
          <li v-for="(item,i) in searchHistory" :key="i" @click="search(item)">{{item}}</li>
          <li class="clear-history" @click="clearHistory" v-show="searchHistory.length>0">清除搜索历史</li>
          <li v-if="searchHistory.length===0">暂无</li>
        </ul>

      </div>
      <!-- 医院列表 -->
      <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
        <div class="reconsult-hosp-list" v-if="menuShow">
            <div class="hosp-item" @click="handleHospital(item)" v-for="item in result" :key="item.phospId" >
                <img class="hosp-logo" src="../../assets/images/jidayi-hospital/icon-hospital.png"/>
                <div class="hosp-content">
                    <div class="hosp-info">
                        <div class="hosp-name">{{ item.name }}</div>
                        <div class="hosp-level">{{ item.hospLevel }}</div>
                    </div>
                    <div class="hosp-mark history" v-if="item.isLastVisit === 'Y'">最近就诊</div>
                </div>
            </div>
            <div class="hosp-item empty" v-if="result && result.length === 0">
              <div class="empty-tip">暂无匹配结果</div>
            </div>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      content: "",
      menuShow: true,
      searchHistory: [],
      result: [],
      allLoaded: false,
      pageNo: 1,
      rows: 20,
      isFocus: false,
      timer: null
    };
  },
  created() {
    this.initSearchHistory();
    this.getList();
  },
  methods: {
    handleHospital(row) {
      this.$router.push({
        name: 'reconsultDocList',
        query: {
          phospId: row.phospId
        }
      })
    },
    initSearchHistory() {
      let hstr = Cookies.get("search_history_hosp");
      this.searchHistory = hstr ? JSON.parse(hstr) : [];
    },
    clearHistory() {
      Cookies.set("search_history_hosp", "");
      this.searchHistory = [];
    },
    focus() {
      this.isFocus = true;
      this.menuShow = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.search();
      }, 200);
    },
    blur() {
      this.menuShow = true;
    },
    clear() {
      this.content = "";
      // this.search();
      this.blur();
    },
    getList(isLoading = true) {
      this.$http
        .getHosps(
          {
            content: this.content
          },
          {
            pageNo: this.pageNo,
            rows: this.rows
          },
          isLoading
        )
        .then(res => {
          if (res && res.length > 0) {
            res.forEach(ele => {
              this.result.push(ele);
            });
            // this.result = res
            this.pageNo++;
          }
          if (res.length < this.rows) {
            this.allLoaded = true; // if all data are loaded
          } else {
            this.$refs.loadmore.onBottomLoaded();
          }
        });
    },
    search(val) {
      if (val) {
        this.content = val;
      }
      // if (!this.content) {
      //   return;
      // }
      this.allLoaded = false;
      this.pageNo = 1;
      this.result = [];
      this.getList(false);
    },
    updateHistory() {
      this.isFocus = false;
      this.menuShow = true;
      if (!this.content) {
        return;
      }
      this.searchHistory.splice(0, 0, this.content);
      if (this.searchHistory.length > 7) {
        this.searchHistory.pop();
      }
      Cookies.set("search_history_hosp", JSON.stringify(this.searchHistory));
    },
    loadBottom() {
      if (!this.content) {
        return;
      }
      this.getList();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/patientEnd/reconsultHospList.vue